import React, { useEffect, useState, useMemo } from "react";
import _ from "lodash";
import { Form, Row, Col } from "react-bootstrap";
import { toast } from "react-toastify";
import useApiClient, { apiRoutes } from "../../../../../hooks/apiClient";

const CheckBoxListaLivros = ({ formik, field, dadosOs, dataInicial, dataFinal, sqComunicado, sqComunicadoIF1 }) => {
  const { values, setFieldValue } = formik;

  const { request: requestIF1, data: dataIF1, errors: errorsIF1 } = useApiClient();

  const [categorias, setCategorias] = useState([]);

  // GERA ANOS
  const years = useMemo(() => {
    const startYear = new Date(dataInicial).getFullYear();
    const endYear = new Date(dataFinal).getFullYear();

    const arr = [];
    for (let year = startYear; year <= endYear; year++) {
      arr.push(year);
    }
    return arr;
  }, [dataInicial, dataFinal]);

  // BUSCA IF1
  useEffect(() => {
    if (sqComunicadoIF1) {
      requestIF1(apiRoutes.fiscalizacao.ordemservico.consultaLivrosFiscaisSalvos, { sqComunicado: sqComunicadoIF1 });
    }
  }, [sqComunicadoIF1, requestIF1]);

  useEffect(() => {
    if (dataIF1?.result) {
      const filtrado = dataIF1.result.filter((c) => c.tipoCategoria !== "AM");
      setCategorias(_.sortBy(filtrado, ["descricaoCategoria"]));
    }

    if (errorsIF1) toast.error(errorsIF1.message);
  }, [dataIF1, errorsIF1]);

  // INICIALIZA CHECKBOXES
  useEffect(() => {
    if (!dataIF1?.result) return;

    // só inicializa se ainda não tiver nada
    if (!sqComunicado && (!values.livrosFiscais || values.livrosFiscais.length === 0)) {
      const todos = [];

      dataIF1.result.forEach((categoria) => {
        categoria.livrosFiscais?.forEach((livro) => {
          years.forEach((ano) => {
            todos.push(`${livro.sequencialLivro}#${ano}`);
          });
        });
      });

      setFieldValue("livrosFiscais", todos);
    }
  }, [dataIF1?.result, years, sqComunicado, values.livrosFiscais, setFieldValue]);

  // HANDLE CHECK
  const handleChange = (e) => {
    const updated = [...values.livrosFiscais];

    if (e.target.checked) {
      if (!updated.includes(e.target.value)) {
        updated.push(e.target.value);
      }
    } else {
      _.remove(updated, (v) => v === e.target.value);
    }
    setFieldValue("livrosFiscais", [...updated]);
  };

  // RENDER
  return (
    <div style={{ width: "100%" }}>
      {categorias
        .filter((categoria) => categoria.livrosFiscais.length > 0)
        .map((categoria) => (
          <div key={categoria.descricaoCategoria}>
            <h6 className="text-primary" style={{ textTransform: "uppercase" }}>
              {categoria.descricaoCategoria}
            </h6>

            <Row>
              <Col sm={12}>
                <ul className="list-group">
                  {categoria.livrosFiscais.map((livro) => (
                    <li
                      key={livro.sequencialLivro}
                      style={{
                        borderBottom: "1px solid rgba(0,0,0,0.1)",
                        padding: "10px",
                      }}
                    >
                      <strong>{livro.nomeLivro}</strong>
                      <br />

                      {years.map((ano) => {
                        const value = `${livro.sequencialLivro}#${ano}`;
                        const checked = values.livrosFiscais.includes(value);

                        return (
                          <Form.Check
                            key={value}
                            inline
                            type="checkbox"
                            value={value}
                            label={ano}
                            checked={checked}
                            onChange={handleChange}
                            name={field}
                          />
                        );
                      })}
                    </li>
                  ))}
                </ul>
              </Col>
            </Row>
          </div>
        ))}
    </div>
  );
};

export default CheckBoxListaLivros;
